<template>
  <div
    v-if="isMember"
    @click="openDrawerMethod"
    class="pointer"
  >
    <v-list-tile avatar>
      <v-list-tile-content>
        <v-list-tile-title :style="myNameStyle">{{ myName }}</v-list-tile-title>
      </v-list-tile-content>
      <v-btn
        v-if="myImg.type === 'icon'"
        icon
        small
      >
        <v-icon
          small
          :color="myImg.color"
        >fas fa-user</v-icon>
      </v-btn>
      <img 
        v-else
        :src="myImg.src"
      >
    </v-list-tile>
  </div>
  <div
    v-else-if="authenticated"
    @click="go2Register2Page"
  >
    <v-list-tile avatar>
      <v-list-tile-content>
        <v-list-tile-title :style="myNameStyle">{{ $t('complete_registration') }}</v-list-tile-title>
      </v-list-tile-content>
      <v-btn
        v-if="myImg.type === 'icon'"
        icon
        small
      >
        <v-icon
          small
          :color="myImg.color"
        >fas fa-user</v-icon>
      </v-btn>
      <img 
        v-else
        :src="myImg.src"
      >
    </v-list-tile>
  </div>
  <div
    v-else
    @click="go2SignInPage"
  >
    <v-list-tile avatar>
      <v-list-tile-content>
        <v-list-tile-title :style="myNameStyle">{{ $t('sign_in') }}</v-list-tile-title>
      </v-list-tile-content>
      <v-btn
        icon
        small
      >
        <v-icon
          small
          :color="theme.toolbar_color"
        >fas fa-user</v-icon>
      </v-btn>
    </v-list-tile>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    openDrawerMethod: {
      type: Function,
      default: () => null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'pictures', 'enableMemberPoints'
    ]),
    ...mapGetters('auth', [
      'authenticated', 'user'
    ]),
    ...mapGetters('member', [
      'points', 'isMember'
    ]),
    myNameStyle () {
      let styles = {
        fontWeight: 700,
        color: this.theme.toolbar_color,
        fontSize: '13px',
        cursor: 'pointer',
        maxWidth: '120px'
      }
      
      return styles
    },
    myName () {
      return this.user && this.user.name ? this.user.name : null
    },
    myImg () {
      if (this.user && this.user.photo) {
        return {
          type: 'img',
          src: this.user.photo
        }
      }
      return {
        type: 'icon',
        color: this.theme.toolbar_color,
      }
    },
    myPoints () {
      return this.enableMemberPoints && this.points !== null ? this.points + ' points' : null
    }
  },
  methods: {
    go2Register2Page () {
      this.$router.push({ name: 'register2' })
    },
    go2SignInPage () {
      this.$router.push({ name: 'login' })
    }
  },
  async created () {
    if (this.isMember) {
      await this.$store.dispatch('member/fetchProfile')
    }
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/ProfileIcon.vue